import { queryOptions } from '@tanstack/react-query';

import { IEventConfiguration } from '@/resources/upgrade/EventConfiguration';
import { apiClient } from '@/resources/upgrade/jsonapi-client';

export function eventConfigurationQueryOptions(eventId: string | undefined) {
  return queryOptions({
    queryKey: ['thin-events', eventId, 'configuration'],
    queryFn: async () => {
      const data = await apiClient.get<IEventConfiguration>(`thin_events/${eventId}/configuration`);

      return data;
    },
    enabled: Boolean(eventId),
    staleTime: 1000 * 60 * 5,
  });
}

// Server-side (getServerSideProps) fetch of the event configuration. Forward the request
// cookie so the call is authenticated the same way the old datx store fetch was.
export function fetchEventConfiguration(eventId: string, cookie?: string) {
  return apiClient.get<IEventConfiguration>(
    `thin_events/${eventId}/configuration`,
    undefined,
    cookie ? { Cookie: cookie } : undefined
  );
}
